var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main",class:( _obj = {
    'is-ascending': _vm.navDirection > 0,
    'is-descending': _vm.navDirection < 0
}, _obj['is-' + _vm.backgroundColor] = true, _obj['is-menu-open'] =  _vm.$store.isMenuOpen, _obj ),attrs:{"id":"app"}},[_c('Background',{attrs:{"color":_vm.backgroundColor,"page-num":_vm.pageNum}}),_c('Header'),_c('transition',{attrs:{"name":"page","mode":"out-in","duration":{ enter: 1000, leave: 1000 }}},[_c('router-view')],1),_c('Footer'),_c('Nav'),_c('Menu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }